import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-40" data-mp="164obkbkmsdwt">
      {open && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[92px] left-3 z-50 w-[calc(100%-24px)] max-w-[340px] sm:bottom-28 sm:left-5" data-id="element-41" data-mp="116wb2t5x7jh0">
          <div className="relative flex items-center gap-3 rounded-2xl border border-navy-100 bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(7,18,36,0.18)]" data-id="element-42" data-mp="i81sta7900w3">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-sand object-contain" data-id="element-43" data-mp="x62jnpt9rmjd" />
            <div className="min-w-0" data-id="element-44" data-mp="s4wollc4zn6o">
              <p className="text-sm leading-snug text-ink" data-id="element-45" data-mp="28k7pypgyg8hv">
                <span className="font-bold" data-id="element-46" data-mp="28imxd5e7azmn">{buyer.name}</span> from {buyer.place}
              </p>
              <p className="text-sm leading-snug text-muted" data-id="element-47" data-mp="23l3ji6lf0ov8">just purchased the Clinical Pathway™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-48" data-mp="2aobgywl24h0q">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-49" data-mp="2fltg5v99vhvj" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-sand hover:text-ink" aria-label="Close notification" data-id="element-50" data-mp="2pm3u5i34stbr">
              <XIcon className="h-4 w-4" data-id="element-51" data-mp="21w9giyazn0qg" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}